import { render, staticRenderFns } from "./NotificationsPanel.vue?vue&type=template&id=3fd4345a"
import script from "./NotificationsPanel.vue?vue&type=script&lang=js"
export * from "./NotificationsPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports